// "Letzte Kennzeichen", IMG_4883 (01.09.2026): die eigenen Eintraege,
// neueste zuerst. Rechnet clientseitig aus Bundle + eigenen Eintraegen,
// kein eigener Endpunkt.

import { Unterseite } from "../bausteine/Unterseite.js";
import { useBundle } from "../lib/bundle.js";
import { useEintraegeSortiert } from "../lib/entries.js";
import { aktiveSammlung } from "../lib/collections.js";
import type { Nutzer, Sammlung } from "../lib/me.js";

function ort(kennzeichenCode: { regionNames: string[]; derivation: string | null; code: string } | undefined): string {
  if (!kennzeichenCode) return "";
  if (kennzeichenCode.regionNames.length > 0) return kennzeichenCode.regionNames.join(" / ");
  return kennzeichenCode.derivation ?? kennzeichenCode.code;
}

export function LetzteKennzeichen({ nutzer, sammlungen }: { nutzer: Nutzer; sammlungen: Sammlung[] }) {
  const bundle = useBundle();
  // Dieselbe Sammlung wie der Hauptscreen, siehe Statistik.tsx.
  const activeCollectionId = (nutzer.settings as { activeCollectionId?: number } | undefined)
    ?.activeCollectionId;
  const sammlung = aktiveSammlung(sammlungen, activeCollectionId);
  const eintraege = useEintraegeSortiert(sammlung?.id);

  const kennzeichenById = new Map((bundle.data?.kennzeichen ?? []).map((k) => [k.id, k]));
  const landById = new Map((bundle.data?.laender ?? []).map((l) => [l.id, l]));

  return (
    <Unterseite
      titel="Letzte Kennzeichen"
      kinder={
        <div className="rounded bg-flaeche-inhalt shadow-sm">
          {eintraege.data.map((eintrag) => {
            const kennzeichen = kennzeichenById.get(eintrag.plateCodeId);
            const land = kennzeichen ? landById.get(kennzeichen.countryId) : undefined;
            return (
              <div
                key={eintrag.plateCodeId}
                className="flex items-center gap-3 border-t border-neutral-100 px-4 py-3 first:border-t-0"
              >
                <span
                  className="flex h-8 w-11 shrink-0 items-center justify-center rounded-sm text-xs font-bold text-white"
                  style={{ backgroundColor: "#003399" }}
                >
                  {land?.plateLetter ?? "?"}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold">{kennzeichen?.code ?? "?"}</div>
                  <div className="truncate text-sm text-neutral-500">{ort(kennzeichen)}</div>
                </div>
                <span className="shrink-0 text-sm text-neutral-500">
                  {new Date(eintrag.firstSeenAt).toLocaleDateString("de-DE")}
                </span>
              </div>
            );
          })}
          {eintraege.data.length === 0 && (
            <p className="px-4 py-6 text-center text-sm text-neutral-500">Noch nichts gesammelt.</p>
          )}
        </div>
      }
    />
  );
}
